import React, {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import * as Yup from 'yup'
import {Modal, Stack, Row} from 'react-bootstrap'
import {alert} from '../../../../../utils/helper'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'
import {FormikProvider, FieldArray, useFormik} from 'formik'

import {
  GET_PRODUCT_FOR_AGENT,
  UPDATE_PRODUCT_FOR_AGENT,
  GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT,
} from '../../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import ProductDetails from '../steps/ProductDetails'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'

const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  editData: any

  refetchList: () => void
  salesData: any
  agentId: string
  agentLeaderList: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const EditAgentModel = ({
  show,
  handleClose,
  editData,

  refetchList,
  salesData,
  agentId,
  agentLeaderList,
}: Props) => {
  const [agentProd, setAgentProd] = useState<any>([])
  const [salesProducts, setSalesProducts] = useState<any>([])

  const [getAgentLeaderCode] = useLazyQuery(GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) =>
      formik.setFieldValue(
        'agentLeaderName',
        agentLeaderList.filter(
          (leader: any) => leader.leaderCode === data.getAgentLeaderInfoForAgent.leaderCode
        )[0].leaderName
      ),
  })
  useEffect(() => {
    const parseData = JSON.parse(editData)
    formik.setFieldValue('productIds', [])
    formik.setFieldValue('deletedProductId', [])
    formik.setFieldValue('agentFirstName', parseData.firstName)
    formik.setFieldValue('agentLastName', parseData.lastName)
    formik.setFieldValue('agentEmailId', parseData.emailId)
    formik.setFieldValue('agentRepId', parseData.repId)
    getProductsForAgents({
      variables: {
        agentId,
      },
    })

    getAgentLeaderCode({
      variables: {
        memberId: agentId,
      },
    })

    setSalesProducts(salesData.products)
  }, [editData])

  const [getProductsForAgents] = useLazyQuery(GET_PRODUCT_FOR_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (agentProduct) => {
      setAgentProd({products: agentProduct.getProductsForAgents})
    },
  })
  const validationSchema = Yup.object().shape({
    agentFirstName: Yup.string().required('Agent First Name required'),
    agentLastName: Yup.string().required('Agent Last Name required'),
    agentEmailId: Yup.string().required('required'),
  })

  const formik = useFormik({
    initialValues: {
      productIds: [],
      deletedProductId: [],
      agentFirstName: '',
      agentLastName: '',
      agentEmailId: '',
      agentLeaderName: '',
      agentRepId: '',
    },
    validationSchema,
    onSubmit: (values) => {
      updateAgent({
        variables: {
          updateAgentInputs: {
            memberId: agentId,
            addProductIds: values.productIds.length ? values.productIds : null,
            removingIds: values.deletedProductId.length ? values.deletedProductId : null,
            salesChannelId: localStorage.getItem('salesEditId'),
            ...(JSON.parse(editData).firstName !== values.agentFirstName && {
              agentFirstName:
                JSON.parse(editData).firstName !== values.agentFirstName
                  ? values.agentFirstName
                  : null,
            }),
            leaderCode: Boolean(values.agentLeaderName)
              ? agentLeaderList.filter(
                  (leader: any) => leader.leaderName === values.agentLeaderName
                )[0].leaderCode
              : null,
            ...(JSON.parse(editData).lastName !== values.agentLastName && {
              agentLastName:
                JSON.parse(editData).lastName !== values.agentLastName
                  ? values.agentLastName
                  : null,
            }),
            ...(JSON.parse(editData).agentRepId !== values.agentRepId && {
              agentRepId: values.agentRepId,
            }),
          },
        },
      })
    },
  })

  const [updateAgent] = useMutation(UPDATE_PRODUCT_FOR_AGENT, {
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Agent updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      handleClose()
      refetchList()
    },
    onError: (error) => alert(error.message, 'error'),
  })
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={'modal-dialog-centered mw-650px'}
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title'>
          {formik.values.agentFirstName} {formik.values.agentLastName}
        </h4>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => {
            formik.setTouched({})
            handleClose()
          }}
        >
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <div className='modal-content'>
          <div className='modal-md'>
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit}>
                <FieldArray
                  name='agentList'
                  render={(arrayHelpers) => (
                    <div className='hover-scroll-overlay-y h-380px p-5'>
                      <Stack direction='vertical' gap={3} className='mb-3 mt-3 '>
                        {/** both these conventions do the same  */}

                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <label className='form-label'>
                            Agent First Name <span className='h5 text-danger'>*</span>
                          </label>
                          <input
                            {...formik.getFieldProps('agentFirstName')}
                            className='form-control form-control-solid'
                            placeholder='First Name'
                            style={{marginLeft: '10px', width: '98%'}}
                          />
                          <div>
                            {formik.touched.agentFirstName && (
                              <div className='fv-plugins-message-container'>
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                >
                                  {formik.errors.agentFirstName}
                                </div>
                              </div>
                            )}
                          </div>
                        </Row>

                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <label className='form-label'>
                            Agent Last Name <span className='h5 text-danger'>*</span>
                          </label>
                          <input
                            {...formik.getFieldProps('agentLastName')}
                            className='form-control form-control-solid'
                            placeholder='Last Name'
                            style={{marginLeft: '10px', width: '98%'}}
                          />
                          <div>
                            {formik.touched.agentLastName && (
                              <div className='fv-plugins-message-container'>
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                >
                                  {formik.errors.agentLastName}
                                </div>
                              </div>
                            )}
                          </div>
                        </Row>

                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <label className='form-label'>
                            Agent Email ID <span className='h5 text-danger'>*</span>
                          </label>
                          <input
                            name={`agentEmailID`}
                            value={formik.values.agentEmailId}
                            onChange={formik.handleChange}
                            className='form-control form-control-solid'
                            placeholder='Email Id'
                            style={{marginLeft: '10px', width: '98%'}}
                            disabled
                          />
                        </Row>
                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <label className='form-label'>Agent RepId</label>
                          <input
                            {...formik.getFieldProps('agentRepId')}
                            className='form-control form-control-solid'
                            placeholder='Agent RepId'
                            style={{marginLeft: '10px', width: '98%'}}
                          />
                          <div>
                            {formik.touched.agentRepId && (
                              <div className='fv-plugins-message-container'>
                                <div
                                  data-field='appname'
                                  data-validator='notEmpty'
                                  className='fv-help-block'
                                >
                                  {formik.errors.agentRepId}
                                </div>
                              </div>
                            )}
                          </div>
                        </Row>

                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <ProductDetails
                            isEdit={false}
                            formik={formik}
                            salesDatas={agentProd}
                            salesProducts={salesProducts}
                            label='Assigned Products'
                          />
                        </Row>
                        <label className='form-label'>Agent Leader</label>
                        <Dropdown
                          fieldName={`agentLeaderName`}
                          optionList={agentLeaderList?.map((leader: any) => ({
                            id: leader.leaderName,
                            value: leader.leaderName,
                          }))}
                          formik={formik}
                          selectedVal={formik.values.agentLeaderName}
                          handleSelectedItem={(e: any, fieldName: any) =>
                            formik.setFieldValue(`agentLeaderName`, e.value)
                          }
                        />
                      </Stack>
                    </div>
                  )}
                />
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    data-bs-dismiss='modal'
                    onClick={() => {
                      formik.setTouched({})
                      handleClose()
                    }}
                  >
                    Discard
                  </button>
                  <button type='submit' className='btn btn-primary'>
                    Submit
                  </button>
                </div>
              </form>
            </FormikProvider>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {EditAgentModel}
